// App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";

import WelcomePage from "./pages/WelcomePage";
import SignUpPage from "./pages/SignUpPage";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";

import ProfilePage from "./pages/ProfilePage";
import PostPage from "./pages/PostPage";
import ViewProfilePage from "./pages/ViewProfilePage";
import SearchResultsPage from "./pages/SearchResultsPage";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import MobileLayout from "./layouts/MobileLayout";

import AdminRoute from "./routes/AdminRoute";
import AdminPage from "./pages/AdminPage";

// ✅ Desktop dashboard home
import DashboardPage from "./pages/DashboardPage";

// ✅ Global Moment Overlay (desktop)
import QuickMomentWrapper from "./pages/QuickMomentWrapper";

function AppLayout() {
  const location = useLocation();

  const publicRoutes = ["/", "/login", "/signup", "/forgot-password"];

  const isPublicPage = publicRoutes.includes(location.pathname);
  const isCameraPage = location.pathname === "/post";
  const isMobileApp = location.pathname.startsWith("/app");

  return (
    <>
      {/* Navbar only on desktop authenticated pages */}
      {!isPublicPage && !isCameraPage && !isMobileApp && <Navbar />}

      {/* Global Moment Overlay (desktop only) */}
      {!isPublicPage && !isMobileApp && <QuickMomentWrapper />}

      <Routes>
        {/* 🔒 SAFETY REDIRECT — NEVER STAY ON /moment/:id */}
       <Route path="/moment/:id" element={<Navigate to="/app" replace />} />


        {/* PUBLIC */}
        <Route path="/" element={<WelcomePage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* MOBILE APP */}
        <Route path="/app/*" element={<MobileLayout />} />

        {/* DESKTOP */}
        <Route path="/explore" element={<DashboardPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/profile/:id" element={<ViewProfilePage />} />
        <Route path="/search" element={<SearchResultsPage />} />

        {/* CAMERA */}
        <Route path="/post" element={<PostPage />} />

        {/* ADMIN */}
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminPage />
            </AdminRoute>
          }
        />
      </Routes>

      {/* Footer only on public pages */}
      {isPublicPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
